/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/explosive_strikes': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<circle pid="0" cx="10" cy="10" r="3"/><path pid="1" d="M15 13h-1v1h-1v1h1v1h1v-1h1v-1h-1zM6 13H5v1H4v1h1v1h1v-1h1v-1H6zM5 7h1V6h1V5H6V4H5v1H4v1h1zM15 5V4h-1v1h-1v1h1v1h1V6h1V5z"/>'
  }
})
